import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CCA_GENERATE_TEMPLATE_INPUTS_MUTATION } from './ccaGenerateTemplateInputs.mutation';
import {
  CcaGenerateTemplateInputsMutation,
  CcaGenerateTemplateInputsMutationVariables
} from './__generated__/CcaGenerateTemplateInputsMutation';

export const useCcaGenerateTemplateInputs = () => {
  return useMutation<CcaGenerateTemplateInputsMutation, CcaGenerateTemplateInputsMutationVariables>(
    CCA_GENERATE_TEMPLATE_INPUTS_MUTATION,
    { client: kmsClient }
  );
};
